
import {Component, Vue} from "vue-property-decorator";
import Base from "@/views/审核管理/view/component/demandBase.vue";
import Address from "@/views/审核管理/view/component/address.vue";
import Contacts from "@/views/审核管理/view/component/contacts.vue";
import nyNetwork from "@/api/nyBaseNetwork";
import DZServiceDemand from "@/views/审核管理/service/DZServiceDemand";

@Component({
    components: {Base,Address,Contacts}
})
export default class Index extends Vue {

    created(){
        this.demand_id = this.$route.query.id as string;
        this.net_list_dic_all()
    }

    mounted(){
        this.action_get_info()
    }

    dic = [];

    demand_id = "";

    serve = new DZServiceDemand();

    net_list_dic_all(){
        nyNetwork.get("字典列表全部",{}, data => {
            this.dic = data
        })
    }

    action_get_info(){
        this.serve.net_demand_info(this.demand_id)
    }

    action_update_base(m){
        this.serve.net_edit_demand_base(m)
    }

    action_update_address(m){
        this.serve.net_edit_address(m)
    }

    action_update_contact(m){
        this.serve.net_edit_contact(m)
    }
}